module.exports = __webpack_public_path__ + "img/imgs4.90e0ae11.png";